import classNames from 'classnames';
import buildInput from './Input';
import styles from './PersonaForm.module.css';
import useSCIMPersona from './useSCIMPersona';
import type {
  BaseStateProps,
  CommonFormProps,
  PersonaScimFormErrors,
  MobxProps,
} from './useCommonState';
import Control from './Control';
import UserSettingsAndAccessForm from 'admin/pages/Users/User/UserSettingsAndAccessForm';
import type { PermissionMap, UserSettings } from 'admin/types';
import { DotsIndicator } from 'common/components';

export default function SCIMBasedForm(props: BaseStateProps & MobxProps & CommonFormProps) {
  const {
    canRevert,
    errors,
    loading,
    onSave,
    revertChanges,
    schema,
    setUserPermissions,
    setUserSettings,
    userPermissions,
    userSettings,
  } = useSCIMPersona(props);
  if (loading) {
    return (
      <div className={classNames(styles.loadingHolder)}>
        <DotsIndicator color="#0e0d0d" size={12} marginTop={30} marginRight={5} />
      </div>
    );
  }
  return (
    <form className={classNames(styles.personaForm)} onSubmit={onSave}>
      <div className={classNames(styles.personaHeader)}>
        {props.selectedPersona
          ? `${props.editMode ? 'Edit ' : ''}${props.selectedPersona.name}`
          : 'Create New Persona'}
      </div>
      {schema.map((inputProps) => {
        if (inputProps.skip) return null;
        const input = buildInput(inputProps);
        return (
          <div key={inputProps.optionName} className={classNames(styles.personaRoot)}>
            {input}
            {errors[inputProps.optionName as keyof PersonaScimFormErrors]?.[0] && (
              <div className={classNames(styles.errorLabel)}>
                {errors[inputProps.optionName as keyof PersonaScimFormErrors]?.[0]}
              </div>
            )}
          </div>
        );
      })}

      <UserSettingsAndAccessForm
        disableAll={!props.editMode}
        isPersonaForm={true}
        userPermissions={(userPermissions || {}) as PermissionMap}
        setUserPermissions={setUserPermissions}
        setUserSettings={setUserSettings}
        userSettings={(userSettings || {}) as UserSettings}
      />
      <Control
        editMode={props.editMode}
        canRevert={canRevert}
        revertChanges={revertChanges}
        type="scim"
        setEditMode={props.setEditMode}
        setPersonaFormState={props.setPersonaFormState}
      />
    </form>
  );
}
